import React from "react";

import { GridApi, ICellRendererParams, RowNode } from "@ag-grid-community/core";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Deal } from "@mapmycustomers/shared/types/entity";

import { messages } from "@app/util/fieldModel/impl/RottingDaysOutField";

import styles from "./RottingCellRenderer.module.scss";

const RottingCellRenderer: React.FC<ICellRendererParams> = ({
  value,
}: {
  api: GridApi;
  node: RowNode;
  value: Deal["rottingDaysOut"];
}) => {
  const intl = useIntl();

  if (!value || !intl) {
    // Wrapping into fragment because this component can't return a plain string.
    // On the other hand it can't return `null` because that's an AgGrid recommendation
    // to return empty strings: https://www.ag-grid.com/react-hooks/#react-null
    return <>{""}</>;
  }

  if (value > 0) {
    return (
      <div className={cn(styles.container, styles.error)}>
        <FontAwesomeIcon icon={faExclamationCircle} />
        <span className={styles.message}>
          {intl.formatMessage(messages.daysRotting, { days: value })}
        </span>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <span className={styles.message}>
        {intl.formatMessage(messages.daysUntilRotting, { days: Math.abs(value) })}
      </span>
    </div>
  );
};

export default RottingCellRenderer;
